import { memo } from "react";
import { Badge } from "@/components/ui/badge";

const PRICING_ROWS = [
  ["iPhone 15 / 15 Pro", "À partir de 179 €", "À partir de 95 €"],
  ["iPhone 14 / 14 Pro", "À partir de 155 €", "À partir de 85 €"],
  ["iPhone 13 / 13 Pro", "À partir de 129 €", "À partir de 69 €"],
  ["iPhone 12 / 12 Pro", "À partir de 109 €", "À partir de 65 €"],
  ["iPhone 11 / XR / XS", "À partir de 95 €", "À partir de 59 €"],
  ["iPhone 8 / SE", "À partir de 69 €", "À partir de 55 €"],
];

export const PricingSection = memo(() => (
  <section className="section-padding bg-slate-50" data-testid="home-pricing-section">
    <div className="container-custom max-w-5xl">
      <div className="text-center mb-10">
        <Badge className="bg-slate-900 text-white px-4 py-2 mb-4 hover:bg-slate-900">Tarifs transparents</Badge>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Tarifs réparation iPhone à Niort</h2>
        <p className="text-lg text-slate-600">
          Pièces premium • Techniciens certifiés Apple • Garantie 6 mois
        </p>
      </div>

      <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-slate-200">
        <table className="w-full">
          <caption className="sr-only">Tarifs réparation écran et batterie iPhone</caption>
          <thead className="bg-slate-900 text-white">
            <tr>
              <th scope="col" className="text-left p-4 font-semibold">Modèle iPhone</th>
              <th scope="col" className="text-center p-4 font-semibold">Remplacement écran</th>
              <th scope="col" className="text-center p-4 font-semibold">Changement batterie</th>
            </tr>
          </thead>
          <tbody>
            {PRICING_ROWS.map((row) => (
              <tr key={row[0]} className="border-t border-slate-100 hover:bg-red-50 transition-colors">
                <td className="p-4 font-medium text-slate-900">{row[0]}</td>
                <td className="p-4 text-center text-red-600 font-semibold">{row[1]}</td>
                <td className="p-4 text-center text-slate-700">{row[2]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="text-center text-sm text-slate-500 mt-6">
        Tarifs indicatifs - diagnostic gratuit. Devis exact sous 24 h.
      </p>
    </div>
  </section>
));

PricingSection.displayName = "PricingSection";
